<template>
  <el-dialog
    class="verify-dialog"
    :title="$t('login.verifyCode.title')"
    :visible.sync="dialogVisible"
    width="360px"
    :close-on-click-modal="false"
    @closed="close"
  >
    <div class="verify-content">
      <div class="tip">{{ $t('login.verifyCode.content', { phoneNumber:phoneNumber}) }}</div>
      <div class="input-wrap">
        <!-- 验证码输入 -->
        <el-input
          v-model.trim="code"
          type="text"
          maxlength="6"
          class="verify-code-input"
        />

        <div
          v-if="showSendBtn"
          class="position-right color-1fa0e8 font-size-14 cursor-pointer"
          @click="handleSendCode"
        >
          <span v-if="isCounting && countdown" style="cursor: not-allowed">{{ $t("login.verifyCode.resend") }} ({{ countdown }}s)</span>
          <span v-else>{{ $t("login.verifyCode.getValidate") }}</span>
        </div>
      </div>
      <div v-if="showErrorNMessage" class="error-msg">{{ $t('login.verifyCode.errorCode') }}</div>
    </div>
    <!-- 操作按钮 -->
    <div slot="footer" class="action-btns">
      <el-button class="btn" @click="handleCancel">{{ $t('login.verifyCode.cancel') }}</el-button>
      <el-button
        class="btn"
        type="primary"
        :loading="loading"
        @click="handleVerify"
      >
        {{ $t('login.verifyCode.continue') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { sendSmsVerifyCode, sendSmsVerifyCodeForLogin } from '@/api/modules/user'
import { createNamespacedHelpers } from 'vuex'
const {
  mapGetters: userMapGetters
} = createNamespacedHelpers('user')

export default {
  name: 'SmsVerifyDialog',
  props: {
    visible: Boolean,
    type: Number, // 验证码的来源：登录、11:提现、账户中心、操作员、密钥,
    showSendBtn: {
      type: Boolean,
      default: true
	  },
    autoSend: {
	  type: Boolean,
      default: true // 是否自动发送
    },
    // needValid
    mobile: String, // 透传手机
    isValid: Boolean,
    params: Object,
    loading: false
  },
  data() {
    return {
      verifyCode: '',
      code: '',
      isCounting: false,
      countdown: 60,
      verifying: false,
      timer: null,
      resolvePromise: null,
      showErrorNMessage: false,
	  mobileNumber: ''
    }
  },
  computed: {
    ...userMapGetters(['accountCenterInfo']),
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    phoneNumber() {
      if (this.mobile) {
        return this.$filters.encryptionPhone(this.mobile)
      } else {
        return this.$filters.encryptionPhone(this.mobileNumber)
      }
    }
  },
  //   watch: {
  //     dialogVisible(newVal) {
  //       if (newVal) {
  //         this.handleSendCode()
  //       }
  //     }
  //   },
  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    async show() {
      if (this.autoSend) {
        const res = await this.handleSendCode()
        console.log('sendCode res', res)
    	if (res && res.statusCode == 102) {
          this.dialogVisible = true
	  	}
	  } else {
        this.dialogVisible = true
        this.startCountdown()
	  }

    //   return new Promise((resolve, reject) => {
    //     this.resolvePromise = resolve
    //   })
    },

    // 发送验证码
    handleSendCode() {
      if (this.isCounting) {
        return
	  }
	  // 登录获取验证码的接口单独调用
      if (this.type == 15) {
        return this.sendLoginSmsVerifyCode()
      } else {
        return this.sendBizSmsVerifyCode()
	  }
    },
    /**
	 * 不同业务场景获取验证码
	 */
    async sendBizSmsVerifyCode() {
      const res = await sendSmsVerifyCode({
        type: this.type
      })

      if (res) {
        if (res.statusCode == 102) {
          this.mobileNumber = res.phoneNo
        }
        this.startCountdown()
	  }
	   return res
    },
    async sendLoginSmsVerifyCode() {
      const res = await sendSmsVerifyCodeForLogin({
        loginName: this.params.loginName,
        userName: this.params.userName
	  })

      if (res) {
        if (res.statusCode == 102) {
          this.mobileNumber = res.phoneNo
        }
        this.startCountdown()
	  }
	   return res
    },
    // 启动倒计时
    startCountdown() {
      this.isCounting = true
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.isCounting = false
          this.countdown = 60
          return
        }
        this.countdown--
      }, 1000)
    },

    // 验证操作
    async handleVerify() {
      if (!this.code.trim()) {
        return this.$message.error(this.$t('login.verifyCode.emptyValidate'))
	  }
	  this.$emit('onValidateCode', this.code.trim())
      // 校验短信验证码
      //   if (this.resolvePromise) {
      //     this.resolvePromise(this.code) // 通知父组件验证
      //   }

    //   this.dialogVisible = false
    },

    // 取消操作
    handleCancel() {
      this.dialogVisible = false
	  this.$emit('onClose')
    //   if (this.resolvePromise) {
    //     this.resolvePromise(false)
    //   }
    },
    // refresh() {
    //   this.resolvePromise = null
    // },
    // 关闭时的清理
    close() {
      this.code = ''
      clearInterval(this.timer)

      this.countdown = 60
      this.isCounting = false
      this.dialogVisible = false
      this.$emit('update:visible', false)
	  this.$emit('onClose')
    }
  }
}
</script>

<style scoped lang="scss">
 .verify-dialog{
  text-align: center;
  ::v-deep  .el-dialog {
    border-radius: 10px;
  }

  .verify-content{
    text-align: left;
    .tip{
      padding-bottom: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0,0,0,0.65);
      line-height: 20px;
      font-weight: 400;
    }
    .input-wrap{
      position: relative;
	  height: 48px;
       .verify-code-input{
        height: 32px;
        border-radius: 30px;
        margin-bottom: 30px;
        ::v-deep .el-input__inner {
          border-radius: 40px !important;
        }
      }
    }

  }
 }
 ::v-deep.position-right {
  position: absolute;
     bottom: 18px;
    right: 12px;
  > span {
    font-weight: bold;
  }
}
.action-btns{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  .btn{
    width: 144px;
    height: 32px;
    border-radius: 18px;
    line-height: 32px;
    padding: 0;
  }
}
.error-msg{
	color: #ff4d4f;
	padding-left: 6px;
}
</style>
